<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <!-- Deleted Account Alert -->
    <div v-show="localDeleted" class="alert alert-danger ...">
      <div v-if="successRestore" class="alert alert-success mx-3 mt-3">
        <i class="fas fa-check me-2"></i>
        تم استعادة الحساب بنجاح
      </div>
      <div>
        <i class="fas fa-exclamation-triangle me-2"></i>
        <strong>تنبيه:</strong> هذا الحساب محذوف منذ {{ formatDate(dataRow.deletedAt) }}
      </div>
      <button 
        type="button" 
        class="btn btn-success btn-sm" 
        :disabled="restoreLoader"
        @click="restoreAccount">
        <span v-show="restoreLoader" class="spinner-border spinner-border-sm me-1"></span>
        <i v-show="!restoreLoader" class="fas fa-undo me-1"></i>
        استعادة الحساب
      </button>
    </div>

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="user-tab" data-bs-toggle="tab" data-bs-target="#user-tab-pane" type="button" role="tab" aria-controls="user-tab-pane" aria-selected="true">بيانات العميل</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="nafath-tab" data-bs-toggle="tab" data-bs-target="#nafath-tab-pane" type="button" role="tab" aria-controls="nafath-tab-pane" aria-selected="false">بيانات نفاذ</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="bank-tab" data-bs-toggle="tab" data-bs-target="#bank-tab-pane" type="button" role="tab" aria-controls="bank-tab-pane" aria-selected="false">بيانات الحساب البنكي</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="account-managers-tab" data-bs-toggle="tab" data-bs-target="#account-managers-tab-pane" type="button" role="tab" aria-controls="account-managers-tab-pane" aria-selected="false">مديرين الحساب</button>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade p-3 show active" id="user-tab-pane" role="tabpanel" aria-labelledby="user-tab" tabindex="0">
                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">الصورة الشخصية:</label>
                    <div>
                      <img v-if="dataRow.avatar" :src="MEDIA_URL+dataRow.avatar" class="img-thumbnail" style="max-width: 200px;" alt="">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">الاسم:</label>
                    <input type="text" class="form-control" v-model="name">
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">رقم الهوية:</label>
                    <div>{{ dataRow.identity }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">الرصيد الحالي:</label>
                      <div class="fw-bold text-success">
                        {{ formattedBalance }}
                      </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">الجوال:</label>
                    <div>{{ dataRow.mobile }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">تفعيل رقم الجوال:</label>
                    <div>{{ (dataRow.mobileVerified)? 'نعم ، مفعّل' : 'لا ، غير مفعّل' }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">البريد الإلكتروني:</label>
                    <div>{{ dataRow.email }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">تفعيل البريد الإلكتروني:</label>
                    <div>{{ (dataRow.emailVerified)? 'نعم ، مفعّل' : 'لا ، غير مفعّل' }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">حالة نفاذ:</label>
                    <div>{{ dataRow.nafathStatus }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">آخر تسجيل دخول:</label>
                    <div class="date-format">{{ (dataRow.lastLogin)? formatDate(dataRow.lastLogin) : '' }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">حالة الحظر:</label>
                    <select v-model="isBlocked" class="form-control">
                      <option :value="false">غير محظور</option>
                      <option :value="true">محظور</option>
                    </select>
                  </div>
                </div>

              </div>
              <!-- Nafath -->
              <div class="tab-pane fade p-3" id="nafath-tab-pane" role="tabpanel" aria-labelledby="nafath-tab" tabindex="0">
                <div v-if="!dataRow.Nafath" class="row">
                  <div class="col">
                    <div class="alert alert-info">لم يتم الحصول على بيانات من قبل نفاذ</div>
                  </div>
                </div>
                <div v-else class="row">
                  <div class="col">
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">معرف المستخدم:</label>
                        <div>{{ dataRow.Nafath.nin }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">كود الجنسية:</label>
                        <div>{{ dataRow.Nafath.nationality }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">رقم إصدار الهوية:</label>
                        <div>{{ dataRow.Nafath.idVersionNumber }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">مكان إصدار الهوية:</label>
                        <div>{{ dataRow.Nafath.idIssuePlace }}</div>
                        <div>{{ dataRow.Nafath.iqamaIssuePlaceDesc }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ إصدار الهوية - ميلادي:</label>
                        <div>{{ dataRow.Nafath.idIssueDateG }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ إصدار الهوية - هجري:</label>
                        <div>{{ dataRow.Nafath.idIssueDate }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ إنتهاء الهوية - ميلادي:</label>
                        <div>{{ dataRow.Nafath.idExpiryDateG }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ إنتهاء الهوية - هجري:</label>
                        <div>{{ dataRow.Nafath.idExpiryDate }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الجنس:</label>
                        <div>{{ dataRow.Nafath.gender }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الاسم الاول:</label>
                        <div>{{ dataRow.Nafath.firstName }}</div>
                        <div>{{ dataRow.Nafath.englishFirstName }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">اسم العائلة:</label>
                        <div>{{ dataRow.Nafath.familyName }}</div>
                        <div>{{ dataRow.Nafath.englishLastName }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">اسم الاب:</label>
                        <div>{{ dataRow.Nafath.fatherName }}</div>
                        <div>{{ dataRow.Nafath.englishSecondName }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">اسم الجد:</label>
                        <div>{{ dataRow.Nafath.grandFatherName }}</div>
                        <div>{{ dataRow.Nafath.englishThirdName }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ الميلاد:</label>
                        <div>{{ dataRow.Nafath.dateOfBirthG }}</div>
                        <div>{{ dataRow.Nafath.dateOfBirthH }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الحالة الاجتماعية:</label>
                        <div>{{ (socialStatusCodeObj[dataRow.Nafath.socialStatusCode] && socialStatusCodeObj[dataRow.Nafath.socialStatusCode][dataRow.Nafath.gender])? socialStatusCodeObj[dataRow.Nafath.socialStatusCode][dataRow.Nafath.gender] : 'غير معروف' }}</div>
                        <div>{{ dataRow.Nafath.socialStatusDesc }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ آخر سفر - خروج:</label>
                        <div>{{ dataRow.Nafath.lastTravelExitDateG }}</div>
                        <div>{{ dataRow.Nafath.lastTravelExitDate }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ آخر سفر - دخول:</label>
                        <div>{{ dataRow.Nafath.lastTravelEntryDateG }}</div>
                        <div>{{ dataRow.Nafath.lastTravelEntryDate }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">محل الميلاد:</label>
                        <div>{{ dataRow.Nafath.placeOfBirth }}</div>
                        <div>{{ dataRow.Nafath.placeOfBirthDesc }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">رقم جواز السفر:</label>
                        <div>{{ dataRow.Nafath.passportNumber }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">رمز المهنة:</label>
                        <div>{{ dataRow.Nafath.occupationCode }}</div>
                        <div>{{ dataRow.Nafath.occupationDesc }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">عدد المعالين:</label>
                        <div>{{ dataRow.Nafath.totalNumberOfCurrentDependents }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">كود الجنسية:</label>
                        <div>{{ dataRow.Nafath.nationalityCode }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الجنسية:</label>
                        <div>{{ dataRow.Nafath.nationalityDesc }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">العنوان الوطني:</label>
                        <div>{{ dataRow.Nafath.nationalAddress }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">قاصر:</label>
                        <div>{{ dataRow.Nafath.isMinor }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">رب الاسرة:</label>
                        <div>{{ dataRow.Nafath.hohInfo }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">قاصر:</label>
                        <div>{{ dataRow.Nafath.isMinor }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">اسم الكفيل:</label>
                        <div>{{ dataRow.Nafath.sponsorName }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الوضع القانوني:</label>
                        <div>{{ dataRow.Nafath.legalStatus }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الحالة الاجتماعية:</label>
                        <div>{{ dataRow.Nafath.socialStatus }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الوضع القانوني:</label>
                        <div>{{ dataRow.Nafath.legalStatus }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">مؤشر الدخول والخروج:</label>
                        <div>{{ dataRow.Nafath.inOutIndecator }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">كود محل الميلاد:</label>
                        <div>{{ dataRow.Nafath.placeOfBirthCode }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Bank Account -->
              <div class="tab-pane fade p-3" id="bank-tab-pane" role="tabpanel" aria-labelledby="bank-tab" tabindex="0">
                <div v-if="!dataRow.Bank" class="row">
                  <div class="col">
                    <div class="alert alert-info">لم يتم إدخال بيانات حساب بنكي من قبل العميل</div>
                  </div>
                </div>
                <div v-else class="row">
                  <div class="col">
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label class="form-label">اسم صاحب الحساب:</label>
                        <div>{{ dataRow.Bank.name }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label class="form-label">اسم البنك:</label>
                        <div>{{ dataRow.Bank.bankName }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label class="form-label">رقم الحساب:</label>
                        <div>{{ dataRow.Bank.iban }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Account Managers -->
              <div class="tab-pane fade p-3" id="account-managers-tab-pane" role="tabpanel" aria-labelledby="account-managers-tab" tabindex="0">
                <AccountManagersPanel v-if="dataRow && dataRow.id" :userId="dataRow.id" :canEdit="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col">
            <button
              type="button"
              class="btn btn-outline-primary"
              data-bs-toggle="modal"
              data-bs-target="#send-client-notification-modal"
              @click="resetNotificationForm"
            >
              <i class="fas fa-bell me-1"></i>
              إرسال تنبيه للعميل
            </button>
          </div>
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->

    <div id="send-client-notification-modal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <form class="modal-content" @submit.prevent="sendNotification">
          <div class="modal-header">
            <h5 class="modal-title">إرسال تنبيه للعميل</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="إغلاق"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">العنوان</label>
              <input v-model.trim="notificationTitle" type="text" class="form-control" required>
            </div>
            <div>
              <label class="form-label">الرسالة</label>
              <textarea v-model.trim="notificationMessage" class="form-control" rows="4" required></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">إلغاء</button>
            <button type="submit" class="btn btn-primary" :disabled="notificationLoader">
              <span v-if="notificationLoader" class="spinner-border spinner-border-sm me-1"></span>
              إرسال التنبيه
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { toast, formatDate } from '@/helpers/tools';
import { mapGetters } from 'vuex';
import AccountManagersPanel from '@/components/AccountManagersPanel.vue';

export default {
  name: 'ClientsForm',
  components: {
    AccountManagersPanel,
  },
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      restoreLoader: false,
      socialStatusCodeObj: {
        '0': {M: 'اعزب', F: 'غير معروف'},
        '1': {M: 'زوجة واحدة', F: 'غير متزوجة'},
        '2': {M: 'زوجتين', F: 'متزوجه'},
        '3': {M: 'ثلاث زوجات', F: 'مطلقه'},
        '4': {M: 'أربع زوجات', F: 'أرمله'},
        '5': {M: 'غير معروف', F: 'مطلقة معلقة'},
      },
      name: '',
      isBlocked: false,
      localDeleted: false,  
      successRestore: false,
      notificationTitle: '',
      notificationMessage: '',
      notificationLoader: false,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL']),
    formattedBalance(){
      if(!this.dataRow || this.dataRow.balance == null)
        return '0 ريال';

      return `${Number(this.dataRow.balance).toLocaleString()} ريال`;
    }
  },
  methods: {
    formatDate,
    resetNotificationForm(){
      this.notificationTitle = '';
      this.notificationMessage = '';
      this.hasError = false;
      this.hasSucess = false;
    },
    async sendNotification(){
      if (!this.dataRow?.id || this.notificationLoader)
        return;

      this.notificationLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      try {
        await this.$http.post(`/api/admin/users/${this.dataRow.id}/notification`, {
          title: this.notificationTitle,
          message: this.notificationMessage,
        });

        this.message = 'تم إرسال التنبيه للعميل بنجاح';
        this.hasSucess = true;
        this.notificationTitle = '';
        this.notificationMessage = '';
        window.bootstrap.Modal.getOrCreateInstance(document.getElementById('send-client-notification-modal')).hide();
      } catch(err) {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      } finally {
        this.notificationLoader = false;
      }
    },
    async restoreAccount() {
      if (!this.dataRow?.id) return;

      this.restoreLoader = true;
      this.hasError = false;

      try {
        await this.$http.put(`/api/admin/users/restore/${this.dataRow.id}`);

        this.successRestore = true;
        
        setTimeout(() => {
          this.successRestore = false;
          this.localDeleted = false;  
        }, 3000);

        this.$emit('restored');  

      } catch(err) {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      }

      this.restoreLoader = false;
    },
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      let payload = {
        name: this.name,
        isBlocked: this.isBlocked,
      }
      
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/users/update/${this.dataRow.id}`, payload);
      else
        return false;
        // api = this.$http.post('/api/admin/users/create', formData);
      api.then(({data}) => {
        if(false){
          toast('تم إضافة الإعلان بنجاح', 'success');
          this.$router.replace('/propertyDoc').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    if(this.dataRow){
      this.name = this.dataRow.name;
      this.isBlocked = this.dataRow.isBlocked;
      this.localDeleted = !!this.dataRow.deletedAt;
    }
  }
}
</script>